import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const resumeStateSelector = (state: RootState) => state.resume;

export const resumeSelectors = {
  isLoading: createSelector(resumeStateSelector, s => s.isLoading),
  isError: createSelector(resumeStateSelector, s => s.isError),
  errorCode: createSelector(resumeStateSelector, s => s.errorCode),
  isSuccess: createSelector(resumeStateSelector, s => s.isSuccess),
  isUninitialized: createSelector(resumeStateSelector, s => s.isUninitialized),
  error: createSelector(resumeStateSelector, s => s.error),
  data: createSelector(resumeStateSelector, s => s.data),
  stepValues: createSelector(resumeStateSelector, s => s.stepValues),
  lastAction: createSelector(resumeStateSelector, s => s.lastAction),
  currentStep: createSelector(resumeStateSelector, s => s.currentStep),
  redirectError: createSelector(resumeStateSelector, s => s.redirectError),
};
